import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { DebugOnly } from './DebugOnly'
import { ChangeAuthSection } from './sections/ChangeAuthSection'
import { JwtDebugSection } from './sections/JwtDebugSection'
import { SwitchThemeSection } from './sections/SwitchThemeSection'
import { ToastSection } from './sections/ToastSection'

export const DebugPanel = () => {
  const [open, setOpen] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)

  const sections = [
    { label: 'Theme', content: <SwitchThemeSection /> },
    { label: 'Auth Override', content: <ChangeAuthSection /> },
    { label: 'JWT Token', content: <JwtDebugSection /> },
    { label: 'Toasts', content: <ToastSection /> },
  ]

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'F2') {
      e.preventDefault()
      setOpen((prev) => !prev)
    }
  }, [])

  useEffect(() => {
    if (!import.meta.env.DEV) {
      return
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  return (
    <DebugOnly>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Debug Panel</Typography>
            <IconButton
              onClick={() => setOpen(false)}
              size="small"
              sx={{ ml: 'auto' }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers>
          <Stack direction="row" spacing={2} sx={{ minHeight: 360 }}>
            <Tabs
              orientation="vertical"
              value={tabIndex}
              onChange={(_event, value: number) => setTabIndex(value)}
              sx={{ borderRight: 1, borderColor: 'divider', minWidth: 180 }}
            >
              {sections.map((section, idx) => (
                <Tab key={section.label} label={section.label} value={idx} />
              ))}
            </Tabs>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>{sections[tabIndex].content}</Box>
          </Stack>
        </DialogContent>
      </Dialog>
    </DebugOnly>
  )
}
